const InvoiceCell = ({ row }: { value: string; row: any }) => {
	return (
		<div className="d-flex flex-row align-items-center" style={{ columnGap: '12px' }}>
			<div className="d-flex justify-content-center align-items-center h-40px w-40px rounded-circle bg-kumopack-secondary-50">
				<img src="/media/icons/kumopack/blue-alert-circle.svg" alt="Blue Alert Circle Icon" />
			</div>
			<span className="text-kumopack-grey-900 fw-bold">
				OEM Transaction - Term {row.original.term}
			</span>
		</div>
	)
}

export default InvoiceCell
